import type { AnchorItem } from './types'

export const ACTIVE_SECTION_TOLERANCE_PX = 4

export const SECTION_ID_SEPARATOR = '\n'

export const EXAMPLE_SECTIONS: AnchorItem[] = [
  { id: 'section-a', title: 'Section A' },
  { id: 'section-b', title: 'Section B' },
  { id: 'section-c', title: 'Section C' },
]
